export const scrollToBlock = (
    targetBlock,
    offset = 0
) => {
    if (targetBlock) {
        const targetOffset = offset ? offset : 0;

        const y =
            targetBlock.getBoundingClientRect().top +
            window.scrollY -
            targetOffset;

        window.scrollTo({ top: y, behavior: 'smooth' });
    }
};



// WEBPACK FOOTER //
// ./src/js/scroll-utils.js